import { render, staticRenderFns } from "./CardOfficial.vue?vue&type=template&id=063763cf&scoped=true&"
import script from "./CardOfficial.vue?vue&type=script&lang=js&"
export * from "./CardOfficial.vue?vue&type=script&lang=js&"
import style0 from "./CardOfficial.vue?vue&type=style&index=0&id=063763cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063763cf",
  null
  
)

export default component.exports